/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geolayerscans2Inputs */

const en_geolayerscans2 = /** @type {(inputs: Geolayerscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room scans`)
};

const de_geolayerscans2 = /** @type {(inputs: Geolayerscans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Room-Scans`)
};

/**
* | output |
* | --- |
* | "Live Room scans" |
*
* @param {Geolayerscans2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geolayerscans2 = /** @type {((inputs?: Geolayerscans2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geolayerscans2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geolayerscans2(inputs)
	return de_geolayerscans2(inputs)
});
export { geolayerscans2 as "geoLayerScans" }